<template>
  <v-container fluid>
    <h4> Questão {{ question.id }} </h4>
    <v-row>
      <v-col
        xl="3"
      >
        <TextLabeled label="Disciplina/Carreira">
          {{ question.subject_name }}
        </TextLabeled>
      </v-col>
      <v-col xl="3">
        <TextLabeled label="Módulo">
          {{ question.module_name }}
        </TextLabeled>
      </v-col>
      <v-col xl="3">
        <TextLabeled label="Sua resposta">
          {{ question.user_answer ? question.user_answer : 'N/A' }}
        </TextLabeled>
      </v-col>
      <v-col xl="3">
        <TextLabeled label="Gabarito">
          {{ question.answer ? question.answer.toUpperCase() : 'N/A' }}
        </TextLabeled>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <PerformanceGraphic
          :school-avg="Number(question.school_grade_rate)"
          :platform-avg="Number(question.platform_rate)"
          :diferencial="Number(question.diff ? question.diff : question.school_grade_rate - question.platform_rate)"
        />
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col class="py-3 custom-bg-gray-light d-flex justify-content-center">
        <div
          class="img-container overflow-auto"
          v-html="question.content"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextLabeled from "@/common/components/TextLabeled";
import PerformanceGraphic from "@/common/components/PerformanceGraphic";


export default {
  components: {
    TextLabeled,
    PerformanceGraphic
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped lang="scss">
.img-container ::v-deep {

  figure{
   margin: 0;
  }

  img{
    width: 100%;
    max-width:500px;
  }
}

.custom-bg-gray-light {
  background: #E7E9EF;
}

</style>
